import _ from 'lodash';
import PropTypes from 'prop-types';

import {FeatureStatus} from '../../../../common/community/constants';

export const REGISTRATION_STATUS = {
    stream: 'stream',
    past: 'past',
    soon: 'soon',
    opened: 'opened',
    closed: 'closed',
    canceled: 'canceled',
    record: 'record',
};

export const ServiceShape = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
});

export const FeatureShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    author: PropTypes.shape({
        displayName: PropTypes.string,
        avatarId: PropTypes.string,
    }),
    createDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    services: PropTypes.arrayOf(ServiceShape),
    status: PropTypes.oneOf(Object.values(FeatureStatus)),
    votesCount: PropTypes.number,
    hasUserVote: PropTypes.bool,
    voteInProgress: PropTypes.bool,
    chat: PropTypes.shape({
        entityId: PropTypes.string.isRequired,
        messagesCount: PropTypes.number,
    }),
});

export const EVENT_OPTIONS = {
    PaginationLimit: 15,
    PaginationPagesCount: 5,
    ListDescTrimCount: 150,
};

export const FEATURE_OPTIONS = {
    PreviewDescTrimCount: 110,
    ListDescTrimCount: 280,
};

export const getDefaultTag = _.memoize((i18n) => ({
    id: -1,
    name: i18n('community', 'label_all-services'),
}));
